import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-one-one-two',
  templateUrl: './two-one-one-two.component.html',
  styleUrls: ['./two-one-one-two.component.scss']
})
export class TwoOneOneTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
